module.exports = __webpack_public_path__ + "static/media/LaptopEnviroDesigner.13386791.jpg";